import React from "react";
import { Box, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment-jalaali";

const toEnDigits = (str) =>
  String(str).replace(/[۰-۹]/g, (d) => "۰۱۲۳۴۵۶۷۸۹".indexOf(d));

function YearsDrop({ year, setYear }) {
  const currentJYear = moment().jYear().toString();

  const rawYear = year?.year ? toEnDigits(year.year) : currentJYear;

  const selectedDate = moment(`${rawYear}/1/1`, "jYYYY/jM/jD");

  return (
    <Box sx={{ flex: 1, minWidth: 160 }}>
      <DatePicker
        views={["year"]}
        label="انتخاب سال"
        value={selectedDate}
        onChange={(newValue) => {
          if (!newValue) return;
          setYear({ year: newValue.jYear().toString() }); // همیشه ASCII ذخیره می‌کنه
        }}
        minDate={moment("1278/1/1", "jYYYY/jM/jD")}
        maxDate={moment("1478/12/29", "jYYYY/jM/jD")}
        renderInput={(params) => (
          <TextField {...params} size="small" helperText={null} fullWidth />
        )}
      />
    </Box>
  );
}


export default YearsDrop;
